import { AuthStep, SelectUrlPart } from '../types';
import { emailRegex } from '../constants/validation';
import { Params } from '../../shared/types';

// TODO: look later/refactor https://github.com/HubSpotEngineering/si-datasync-fe/issues/132
export function validateAuthStep(step: AuthStep, params: Params): boolean {
  for (let i = 0; i < step.items.length; i++) {
    const { item } = step.items[i];

    switch (item.type) {
      case 'Password':
      case 'Text':
      case 'TextArea':
        if (item.required && !params[item.name]) {
          return false;
        }
        break;

      case 'Select': {
        if (item.required) {
          const value = params[item.name];

          if (
            !value ||
            item.options.findIndex((o) => o.value === value) === -1
          ) {
            return false;
          }
        }
        break;
      }

      case 'Email':
        if (item.required && !emailRegex.test(params[item.name] as string)) {
          return false;
        }
        break;

      case 'Url':
        for (let j = 0; j < item.parts.length; j++) {
          const part = item.parts[j];

          const values = (params[item.name] as Array<string>) || [];

          switch (part.type) {
            case 'Select': {
              const partValue = values[j];
              if (
                item.required &&
                (partValue === undefined ||
                  !(part as SelectUrlPart).options.includes(partValue))
              ) {
                return false;
              }
              break;
            }

            case 'Domain':
            case 'Path':
              if (item.required && !values[j]) {
                return false;
              } else if (
                values[j] &&
                part.validation &&
                !new RegExp(part.validation.regex).test(values[j])
              ) {
                return false;
              }
              break;

            default:
              continue;
          }
        }
        break;

      default:
        continue;
    }
  }

  return true;
}
